import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  Box,
  Grid,
  Typography,
  Paper,
  useTheme,
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import { getLogeedInUserDetailAction, updateLogeedInUserDetailAction } from "../../../redux/actions/userActions";



import { useNavigate } from 'react-router-dom';
import PhoneNumberField from "../../../common/PhoneNumberField";

export default function UserProfileForm({ user, toggleForm }) {
    const theme = useTheme();
    const dispatch = useDispatch();
    const get_user_profile_data = useSelector((state) => state.user.loggedInUser);

    const navigate = useNavigate();
    const [prefix, setPrefix] = useState("");
    const [firstName, setFirstName] = useState("");
    const [middleName, setMiddleName] = useState("");
    const [lastName, setLastName] = useState("");
    const [suffix, setSuffix] = useState("");
    const [email, setEmail] = useState("");
    const [emailConfirm, setEmailConfirm] = useState("");
    const [userName, setUserName] = useState("");

    const [phone, setPhone] = useState("");
    const [homePhone, setHomePhone] = useState("");
    
    const [faxNumber, setFaxNumber] = useState("");
    const [workPhone, setWorkPhone] = useState("");
    const [defaultLocation, setDefaultLocation] = useState("");
    const [roles, setRole] = useState("");
    const [status, setStatus] = useState("");
    const userId = useSelector((state) => state.user?.user);

    const [errors, setErrors] = useState({});

    let locationList = [];
    if (get_user_profile_data?.defaultLocation) {
      locationList = [{
        value: get_user_profile_data.defaultLocation.id,
        label: get_user_profile_data.defaultLocation.name,
      }];
    }

 

  useEffect(() => {
  if (get_user_profile_data) {
    const userData = get_user_profile_data;

        setPrefix(userData.prefix || "");
        setFirstName(userData.firstName || "");
        setMiddleName(userData.middleName || "");
        setLastName(userData.lastName || "");
        setSuffix(userData.suffix || "");
        setEmail(userData.email || "");
        setEmailConfirm(userData.email || "");
        setUserName(userData.userName || "");
        setPhone(formatPhoneNumber(userData.phone || ""));
        setHomePhone(formatPhoneNumber(userData.homePhone || ""));
        setFaxNumber(formatPhoneNumber(userData.faxNumber || ""));
        setWorkPhone(formatPhoneNumber(userData.workPhone || ""));
       
        setStatus(userData.status || "");
        setDefaultLocation(userData.defaultLocation?.id || "");
        setRole(userData.newRole?.displayName || "");
      }
    }, [get_user_profile_data]);

   useEffect(() => {
  dispatch(getLogeedInUserDetailAction());
}, [dispatch]);

    const handleSubmit = (event) => {
        event.preventDefault();

      const formData = {
        prefix,
        firstName,
        middleName,
        lastName,
        suffix,
        email,
        emailConfirm,
        status,
        userName,
        phone: toE164Format(phone),
        homePhone: toE164Format(homePhone),
        faxNumber: toE164Format(faxNumber),
        workPhone: toE164Format(workPhone),
        cellPhone: null,
        defaultLocation,
        role : 'SUPER',
      };

      const handleResponse = (response,error) => {
        if (response) {
          toggleForm();
        } else if (error && error.errors && error.errors.length > 0) {
          const newErrors = {};

          error.errors.forEach(({ errorMessage, target }) => {

            if (target.toLowerCase().includes("username")) {
              newErrors.userName = errorMessage;
            } else if (target.toLowerCase().includes("email")) {
              newErrors.email = errorMessage;
            } else {
              newErrors.general = errorMessage || "An error occurred. Please check your inputs.";
            }
          });
          setErrors(newErrors);
        }
      };


      if (userId) {
        const updatedFormData = {
          ...formData,
          id: userId.id,
        };
        dispatch(updateLogeedInUserDetailAction(updatedFormData, handleResponse));
      }
    };

    let rolesList = [];
    if (get_user_profile_data?.newRole) {
      rolesList = [{
        value: get_user_profile_data.newRole.displayName,
        label: get_user_profile_data.newRole.displayName,
      }];
    }

    const formatPhoneNumber = (value) => {
      if (!value) return "";

      let phone = value.replace(/\D/g, "");

      if (phone.length === 11 && phone.startsWith("1")) {
        phone = phone.slice(1);
      }

      if (phone.length <= 3) return phone;
      if (phone.length <= 6) return `${phone.slice(0, 3)}-${phone.slice(3)}`;
      return `${phone.slice(0, 3)}-${phone.slice(3, 6)}-${phone.slice(6, 10)}`;
    };

    const toE164Format = (formattedNumber) => {
      if (!formattedNumber) return '';
      const digitsOnly = formattedNumber.replace(/[^\d]/g, "");
      if (digitsOnly.length === 10) {
        return `+1${digitsOnly}`;
      }
      return '';
    };

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(2),
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: "100%",
          maxWidth: 1200,
          padding: theme.spacing(3),
          borderRadius: theme.shape.borderRadius,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            marginBottom: 4,
            textAlign: "center",
          }}
        >
          {user ? "Edit User Profile ss" : "Edit User Profile"}
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="body1"
              >
                Prefix
              </Typography>
              <FormControl fullWidth>
                <Select
                  value={prefix}
                  onChange={(e) => setPrefix(e.target.value)}
                  id="prefix"
                  name="prefix"
                >
                  <MenuItem value="Mr.">Mr.</MenuItem>
                  <MenuItem value="Ms.">Ms.</MenuItem>
                  <MenuItem value="Mrs.">Mrs.</MenuItem>
                  <MenuItem value="Dr.">Dr.</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "19.6px",
                  textAlign: "left",
                  marginBottom: "8px",
                }}
              >
                First Name
              </Typography>
              <TextField
                required
                fullWidth
                value={firstName}
                onChange={(e) => {
                  if (
                    /^[A-Za-z\s]*$/.test(e.target.value) ||
                    e.target.value === ""
                  ) {
                    setFirstName(e.target.value);
                  }
                }}
                id="firstname"
                name="firstName"
                error={!!errors.firstName}
                helperText={errors.firstName}
                inputProps={{ maxLength: 30 }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "19.6px",
                  textAlign: "left",
                  marginBottom: "8px",
                }}
              >
                Middle Name
              </Typography>
              <TextField
                fullWidth
                value={middleName}
                onChange={(e) => {
                  if (
                    /^[A-Za-z\s]*$/.test(e.target.value) ||
                    e.target.value === ""
                  ) {
                    setMiddleName(e.target.value);
                  }
                }}
                id="middlename"
                name="middleName"
                inputProps={{ maxLength: 30 }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "19.6px",
                  textAlign: "left",
                  marginBottom: "8px",
                }}
              >
                Last Name
              </Typography>
              <TextField
                required
                fullWidth
                value={lastName}
                onChange={(e) => {
                  if (
                    /^[A-Za-z\s]*$/.test(e.target.value) ||
                    e.target.value === ""
                  ) {
                    setLastName(e.target.value);
                  }
                }}
                id="lastname"
                name="lastName"
                error={!!errors.lastName}
                helperText={errors.lastName}
                inputProps={{ maxLength: 30 }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "19.6px",
                  textAlign: "left",
                  marginBottom: "8px",
                }}
              >
                Suffix
              </Typography>
              <FormControl fullWidth>
                <Select
                  value={suffix}
                  onChange={(e) => setSuffix(e.target.value)}
                  id="suffix"
                  name="suffix"
                >
                  <MenuItem value="Jr.">Jr.</MenuItem>
                  <MenuItem value="Sr.">Sr.</MenuItem>
                  <MenuItem value="II">II</MenuItem>
                  <MenuItem value="III">III</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography
                variant="h6"
                sx={{ color: theme.palette.success.main, marginY: 2 }}
              >
                Account Status: Active
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "19.6px",
                  textAlign: "left",
                  marginBottom: "8px",
                }}
              >
                Email Address
              </Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={email}
                onChange={(e) => {
                  const email = e.target.value;
                  setEmail(email);
                }}
                id="email"
                name="email"
                inputProps={{ maxLength: 50 }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "19.6px",
                  textAlign: "left",
                  marginBottom: "8px",
                }}
              >
                Confirm Email
              </Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={emailConfirm}
                onChange={(e) => {
                  const confirmEmail = e.target.value;
                  setEmailConfirm(confirmEmail);
                }}
                id="emailconfirm"
                name="emailConfirm"
                inputProps={{ maxLength: 50 }}
              />
            </Grid>


            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "19.6px",
                  textAlign: "left",
                  marginBottom: "8px",
                }}
              >
                User Name
              </Typography>
              <TextField

                autoComplete="off"
                fullWidth
                value={userName}
                id="username"
                onChange={(e) => {
                  if (/^[A-Za-z\s]*$/.test(e.target.value) || e.target.value === "") {
                    setUserName(e.target.value);
                  }
                }}
                inputProps={{ maxLength: 30 }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <PhoneNumberField
                fullWidth
                autoComplete="off"
                value={phone}
                onChange={(e) => {
                  const formatted = formatPhoneNumber(e.target.value);
                  setPhone(formatted);
                }}
                id="phone"
                name="phone"
                label="Phone"
                required={false}
                inputProps={{ maxLength: 12 }} 
                labelStyle={{ fontSize: 14, fontWeight: 500,mb:1}}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              
              <PhoneNumberField
                fullWidth
                value={homePhone}
                autoComplete="off"
                onChange={(e) => {
                  const formatted = formatPhoneNumber(e.target.value);
                  setHomePhone(formatted);
                }}
                id="homephone"
                name="homePhone"
                inputProps={{ maxLength: 12 }}
                 label=" Home Phone"
                required={false}
                 labelStyle={{ fontSize: 14, fontWeight: 500,mb:1}}

              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Poppins",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "19.6px",
                textAlign: "left",
                marginBottom: "8px",
              }}
            >
              Fax Number
            </Typography>
            <TextField
                fullWidth
                autoComplete="off"
                value={faxNumber}
                onChange={(e) => {
                  const formatted = formatPhoneNumber(e.target.value);
                  setFaxNumber(formatted);
                }}
                id="faxnumber"
                name="faxNumber"
                inputProps={{ maxLength: 12 }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <PhoneNumberField
                  fullWidth
                  value={workPhone}
                  onChange={(e) => {
                    const formatted = formatPhoneNumber(e.target.value);
                    setWorkPhone(formatted);
                  }}
                  id="workphone"
                  name="workPhone"
                  inputProps={{ maxLength: 12 }}
                   label=" Work Phone"
                   required={false}
                   labelStyle={{ fontSize: 14, fontWeight: 500,mb:1}}
                />

            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body1" sx={{ fontFamily: "Poppins", fontSize: "14px", fontWeight: "500", marginBottom: "8px" }}>
                Role
              </Typography>
              <Select
                fullWidth
                value={roles || ""}
                id="roles"
                name="roles"
                displayEmpty
                disabled
              >
                {rolesList.map((role) => (
                  <MenuItem key={role.value} value={role.value}>
                    {role.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body1" sx={{ fontFamily: "Poppins", fontSize: "14px", fontWeight: "500", marginBottom: "8px" }}>
                Default Location
              </Typography>
              <Select
                fullWidth
                value={defaultLocation}
                id="defaultlocation"
                name="defaultLocation"
                displayEmpty
                disabled
              >
                {locationList.map((location) => (
                  <MenuItem key={location.value} value={location.value}>
                    {location.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "19.6px",
                  textAlign: "left",
                  marginBottom: "8px",
                }}
              >
                Status
              </Typography>
              <FormControl fullWidth>
                <Select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  id="status"
                  name="status"
                  disabled
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Not Active">Not Active</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginTop: 4,
            }}
          >
            <Button id="cancelbutton" onClick={() => navigate('/home')} variant="outlined"            >
              Cancel
            </Button>
            <Button id="submitbutton"type="submit" variant="contained">
              {user ? "Update" : "Update"}
            </Button>
          </Grid>
        </form>
      </Paper>
    </Box>
  );
}